import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import toast from "react-hot-toast";
import { V_URL } from "../../../../BaseUrl";

export const generatePrFromAdminBom = createAsyncThunk(
    "/admin/generate-pr-from-bom",
    async (id) => {
        try {
            const myurl = `${V_URL}/believe/generate-pr-bom/${id}`;
            const response = await axios({
                method: "post",
                url: myurl,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("VA_TOKEN"),
                },
            });
            const data = response.data;
            if (data.success === true) {
                return data;
            } else {
                throw new Error(data.message || "Failed to generate PR");
            }
        } catch (error) {
            console.error("Error in generatePrFromAdminBom:", error);
            toast.error(error.response?.data?.message || "Failed to generate PR from BOM");
            throw error;
        }
    }
);

const generatePrBomSlice = createSlice({
    name: "generatePrBom",
    initialState: {
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(generatePrFromAdminBom.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(generatePrFromAdminBom.fulfilled, (state) => {
                state.loading = false;
                state.error = null;
            })
            .addCase(generatePrFromAdminBom.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            });
    },
});

export default generatePrBomSlice.reducer;
